import { render, staticRenderFns } from "./BoardMultisucursal.vue?vue&type=template&id=6d34f4a6&scoped=true&"
import script from "./BoardMultisucursal.vue?vue&type=script&lang=js&"
export * from "./BoardMultisucursal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d34f4a6",
  null
  
)

export default component.exports